import { Divider as MuiDivider } from '@mui/material';

export const Divider = () => <MuiDivider sx={{ borderColor: 'Black', mt: 4, mb: 4 }} />;
